import { useQuery } from '@fv/client-core'

import type { AdminLoad } from '@/types/admin-load'
import { adminFetch } from '@/utils'

async function fetchLoad(id: string) {
  return adminFetch<AdminLoad>(`/loads/${id}`)
}

export function useFetchLoad(id?: string) {
  return useQuery<AdminLoad>(['load', id], () => fetchLoad(id ?? ''), {
    enabled: Boolean(id),
  })
}
